import { useEffect, useRef, type RefObject } from 'react'
import type { TableController } from '@v2/table'

/** Text follows the physical source without putting animation frames into React state. */
export function EffectLabels({ controller }: { controller: RefObject<TableController | null> }) {
  const root = useRef<HTMLDivElement>(null)
  useEffect(() => {
    let frame = 0
    const elements = new Map<string, HTMLDivElement>()
    const tick = () => {
      const labels = controller.current?.effectLabels() ?? []
      const current = new Set(labels.map(label => label.id))
      for (const [id, element] of elements) if (!current.has(id)) { element.remove(); elements.delete(id) }
      for (const label of labels) {
        let element = elements.get(label.id)
        if (!element) {
          element = document.createElement('div'); element.className = 'tt-effect-label'; element.textContent = label.text
          root.current?.append(element); elements.set(label.id, element)
        }
        element.style.color = label.color
        element.style.left = `${Math.max(85, Math.min(innerWidth - 85, label.x))}px`
        element.style.top = `${Math.max(80, Math.min(innerHeight - 70, label.y))}px`
        element.style.opacity = String(label.opacity)
      }
      frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => { cancelAnimationFrame(frame); elements.forEach(element => element.remove()) }
  }, [controller])
  return <div ref={root} className="tt-effect-labels" aria-live="polite" aria-atomic="false"/>
}
